__turbopack_context__.v({
  "badge": "PrizeBanner-module__0EIy4q__badge",
  "container": "PrizeBanner-module__0EIy4q__container",
  "desktopOnly": "PrizeBanner-module__0EIy4q__desktopOnly",
  "headingSubtext": "PrizeBanner-module__0EIy4q__headingSubtext",
  "popupBadge": "PrizeBanner-module__0EIy4q__popupBadge",
  "popupButtonContainer": "PrizeBanner-module__0EIy4q__popupButtonContainer",
  "prizeBadge": "PrizeBanner-module__0EIy4q__prizeBadge",
  "prizeCriteria": "PrizeBanner-module__0EIy4q__prizeCriteria",
  "table": "PrizeBanner-module__0EIy4q__table",
  "tierInfoButton": "PrizeBanner-module__0EIy4q__tierInfoButton",
});
